const alldayjs = require('dayjs');
const relativeTime = require('dayjs/plugin/relativeTime');

alldayjs.extend(relativeTime);

module.exports =  {alldayjs};